import { Modal } from '../modal';
import { CreateListModalType } from './type';

export default function CreateListModal({
  children,
  modal,
  setModal,
  modalHeading,
  closeModal,
  className
}: Readonly<CreateListModalType>) {
  const onModalClose = () => {
    setModal(false);
    closeModal();
  };
  return (
    <Modal
      isActive={modal}
      onBlModalClose={() => onModalClose()}
      className={`${className} cat-u-theme-typography-title-sm`}
      heading={modalHeading}
    >
      {children}
    </Modal>
  );
}
